import API from '../../helpers/interceptor';

// ── IOD User Master ───────────────────────────────────────────────────────────

export const listIodUsers = () =>
  API.post('/iod-user/list', {});

export const getIodUser = (userId) =>
  API.post('/iod-user/get', { userId });

export const saveIodUser = (userData) =>
  API.post('/iod-user/save', userData);

export const toggleIodUserStatus = (userId, status) =>
  API.post('/iod-user/toggle-status', { userId, status });

export const getIodUserHistory = (userId) =>
  API.post('/iod-user/history', { userId });

export const getIodUsersByRole = (roleCode) =>
  API.post('/iod-user/by-role', { roleCode });

export const getAllIodDealers = () =>
  API.get('/iod-user/all-dealers');

// ── IOD Role Master ───────────────────────────────────────────────────────────

export const listIodRoles = () =>
  API.post('/role/getroles', {});

export const saveIodRole = (roleData) =>
  API.post('/role/update', roleData);

export const getIodRoleHistory = (roleCode) =>
  API.post('/role/getrolehistory', { roleCode });

export const getIodAvailableMenus = () =>
  API.post('/role/getavailablemenus', {});

// ── IOD Masters (for assignment dropdowns) ────────────────────────────────────

export const getIodCompanies = () =>
  API.get('/iod-master/companies');

export const getIodRegions = () =>
  API.get('/iod-master/regions');

export const getIodDivisions = () =>
  API.get('/division/getdivisions');
